import {ActionType, createStandardAction} from "typesafe-actions";
import {Option} from "react-multi-select-component/dist/lib/interfaces";
import {AuthInfo, IndexWord} from "../models/models";



export let Actions = {
	setAuthInfoAction: createStandardAction("setUserAction")<AuthInfo>(),

	setSelectedSearchDictionaryGroups: createStandardAction("setSelectedSearchDictionaryGroups")<Option[]>(),

	setIndexWordsAction: createStandardAction("getWordsAction")<{ startIndex: number, stopIndex: number, loadedIndexWords: IndexWord[] }>(),
	setIndexWordsCountAction: createStandardAction("setIndexWordsCountAction")<number>(),
	addIndexWordAction: createStandardAction("addWordAction")<IndexWord>(),
	updateIndexWordAction: createStandardAction("updateIndexWordAction")<IndexWord>(),
	deleteIndexWordAction: createStandardAction("deleteWordAction")<number>(),
	checkDeleteIndexWordAction: createStandardAction("checkDeleteIndexWordAction")<{ indexWordIndex: number, deleteChecked: boolean }>(),
	deleteDeleteCheckedIndexWordsAction: createStandardAction("DeleteDeleteCheckedIndexWordsAction")(),
};



export type ActionStrong = ActionType<typeof Actions>;